import React from "react";
import { Link } from "react-router-dom";
import "./Membership.css";
import HeroSection from "../HeroSection";
import Register from "../Register";
import Offer from "../Offer";
import Newsletter from "../Newsletter";
import Footer from "../Footer";
import aboutImage from "./assets/about-us-image.jpg";

const Membership = () => {
  return (
    <main className="membership-page">
      <HeroSection
        title="Nem vagy egyedül. Együtt könnyebb a beszéd."
        text="Csatlakozz közösségünkhöz, ahol megértés, támogatás és fejlődési lehetőség vár. Legyél részese egy olyan csapatnak, ahol minden hang számít."
      />

      <Register />

      <section className="about-us-section">
        <div className="about-us-container">
          <div
            className="about-us-image about-us-image--desktop"
            style={{ backgroundImage: `url(${aboutImage})` }}
          />

          <div className="about-us-text">
            <h2 className="heading-md">Kik vagyunk?</h2>

            <p>
              Olyan dadogó érintettek vagyunk, akik aktívan szeretnénk tenni
              önmagunkért és egymásért. Megjeleníteni a dadogó emberek hangját,
              hogy minél több érintett találjon támogató közösségre nálunk.
              Alakítani a társadalom elképzeléseit és hozzáállását a
              dadogáshoz.
            </p>

            <div
              className="about-us-image about-us-image--mobile"
              style={{ backgroundImage: `url(${aboutImage})` }}
            />

            <Link to="/about" className="button-secondary">
              Olvass rólunk többet
            </Link>
          </div>
        </div>
      </section>

      <section className="membership-offer">
        <Offer />
      </section>

      <Newsletter twoColumn={true} />
      <Footer />
    </main>
  );
};

export default Membership;